<app-header></app-header>
<!-- ======= Hero Section ======= -->
<section id="hero" class="d-flex flex-column justify-content-end align-items-center">
    <div id="heroCarousel" class="container carousel carousel-fade" data-ride="carousel">

        <!-- Titulo -->
        <div class="carousel-item active">
            <div class="carousel-container" style="height: 100%;">
                <h2 class="mt-4 animate__animated animate__faster animate__fadeInDown" style="margin-bottom: 0px;">
                    Administrar la Plataforma
                </h2>

                <app-loader *ngIf="isLoading" class="mt-4"></app-loader>

                <!-- ======= PIN Section ======= -->
                <section id="pricing" class="pricing" *ngIf="!isLoading && !isVerified">
                    <div class="box" data-aos="zoom-in" data-aos-delay="300">
                        <span class="advanced">Seguridad</span>
                        <h3>Introduzca el PIN <span style="font-size: 8px;"> v1.0</span></h3>
                        <input (keydown.enter)="comprobar()" type="password" id="PIN" class="form-control form-control-lg input">
                        <div class="btn-wrap">
                            <a (click)="comprobar()" class="btn-buy text-white">Aceptar</a>
                        </div>
                    </div>
                </section>
                <!-- End PIN Section -->

                <section *ngIf="isVerified && !isLoading" id="services" class="services" style="padding: 1rem;width: 100%;">
                    <div class="container">
                        <a data-toggle="modal" data-target="#plantilla" class="btn-get-started mb-4 animate__animated animate__faster animate__fadeInDown" style="padding: .25rem .5rem;font-size: .875rem;line-height: 1.5;width: 200px;">
                            <i class="icofont-list"></i> Plantillas
                        </a>

                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text"><i class="icofont-search-2"></i></div>
                            </div>
                            <input type="text" id="buscarInput" (keyup)="buscar()" class="form-control" placeholder="Buscar por url...">
                        </div>

                        <table class="table table-bordered table-sm animate__animated animate__faster animate__fadeInDown" id="tableQuinielas">
                            <thead>
                                <tr>
                                    <th class="text-white" scope="col">URL</th>
                                    <th scope="col" class="text-center text-white d-none d-sm-none d-md-block">USUARIO</th>
                                    <th class="text-white" scope="col">OPCIONES</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let quiniela of quinielas">
                                    <td class="text-white">{{ quiniela.url }}</td>
                                    <td class="text-white d-none d-sm-none d-md-block">{{ quiniela.user }}</td>
                                    <td class="text-white">
                                        <a routerLink="/{{ quiniela.url }}" target="_blank">
                                            <i class="icofont-eye-alt" style="color: #fff"></i>
                                        </a>
                                        |
                                        <a routerLink="/quiniela/{{ quiniela.$key }}" target="_blank">
                                            <i class="icofont-settings" style="color: #28a745"></i>
                                        </a>
                                        |
                                        <a href="#" data-toggle="modal" [attr.data-target]="'#editar-' + quiniela.$key">
                                            <i class="icofont-ui-edit" style="color: #ef6603"></i>
                                        </a>
                                        |
                                        <a href="#" data-toggle="modal" [attr.data-target]="'#Eliminar' + quiniela.$key">
                                            <i class="icofont-ui-delete" style="color: #dc3545"></i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </section>
                <!-- End Services Section -->
            </div>
        </div>
    </div>

    <!-- Modal para Editar una Quiniela-->
    <div *ngFor="let quiniela of quinielas" class="modal fade" id="editar-{{quiniela.$key}}" tabindex="-1" role="dialog" aria-labelledby="crearLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="crearLabel">Editar quiniela</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                           <span aria-hidden="true">&times;</span>
                       </button>
                </div>
                <form>
                    <div class="modal-body">
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">Teléfono</div>
                            </div>
                            <input type="text" id="Telefono-{{quiniela.$key}}" class="form-control" value="{{quiniela.telefono}}">
                        </div>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">&nbsp;&nbsp;&nbsp;Email&nbsp;&nbsp;&nbsp;</div>
                            </div>
                            <input type="text" id="Email-{{quiniela.$key}}" class="form-control" value="{{quiniela.email}}">
                        </div>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">&nbsp;&nbsp;Titulo&nbsp;&nbsp;&nbsp;</div>
                            </div>
                            <input type="text" id="Titulo-{{quiniela.$key}}" class="form-control" value="{{quiniela.titulo}}">
                        </div>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">Descripción</div>
                            </div>
                            <textarea class="form-control" id="Descripcion-{{quiniela.$key}}" rows="3" value="{{quiniela.descripcion}}"></textarea>
                        </div>
                        <div class="input-group mb-2">
                            <input type="text" id="URL-{{quiniela.$key}}" class="form-control text-center" disabled value="tuquinielaya.web.app/{{quiniela.url}}">
                        </div>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">&nbsp;&nbsp;Precio&nbsp;&nbsp;</div>
                            </div>
                            <input type="number" id="Precio-{{quiniela.$key}}" class="form-control" value="{{quiniela.precio}}">
                        </div>

                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">&nbsp;&nbsp;Moneda&nbsp;&nbsp;</div>
                            </div>
                            <input type="text" id="Moneda-{{quiniela.$key}}" class="form-control" value="{{quiniela.moneda}}">
                        </div>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">&nbsp;&nbsp;Porcentaje a repartir&nbsp;&nbsp;</div>
                            </div>
                            <input type="number" id="Porcentaje-{{quiniela.$key}}" class="form-control" autocomplete="off" min="0" max="100" value="{{quiniela.porcentaje}}">
                        </div>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">Datos de Pago</div>
                            </div>
                            <textarea class="form-control" id="DatosPago-{{quiniela.$key}}" rows="3" value="{{quiniela.datos_de_pago}}"></textarea>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" id="CloseEditarButton-{{quiniela.$key}}" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                        <button type="button" (click)="editar(quiniela)" class="btn btn-primary" style="background: #ef6603;color: #fff;border-color: #ef6603;">Guardar</button>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <!-- Modal para Eliminar una Quiniela-->
    <div *ngFor="let quiniela of quinielas" class="modal fade" id="Eliminar{{quiniela.$key}}" tabindex="-1" role="dialog" aria-labelledby="crearLabel" aria-hidden="true">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="crearLabel">Alerta</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form>
                    <div class="modal-body">
                        <p class="text-dark text-center" style="width: 100%;">¿Usted esta seguro que desea eliminar esta quiniela?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" id="CloseEliminarButton-{{quiniela.$key}}" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                        <button type="button" (click)="eliminar(quiniela)" class="btn btn-primary" style="background: #dc3545;color: #fff;border-color: #dc3545;">Eliminar</button>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <svg class="hero-waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28 " preserveAspectRatio="none">
        <defs>
            <path id="wave-path" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
        </defs>
        <g class="wave1">
            <use xlink:href="#wave-path" x="50" y="3" fill="rgba(255,255,255, .1)" />
        </g>
        <g class="wave2">
            <use xlink:href="#wave-path" x="50" y="0" fill="rgba(255,255,255, .2)" />
        </g>
        <g class="wave3">
            <use xlink:href="#wave-path" x="50" y="9" fill="#fff" />
        </g>
    </svg>


</section>
<!-- End Hero -->


<!-- Modal para ver las plantillas -->
<div class="modal fade" id="plantilla" tabindex="-1" role="dialog" aria-labelledby="crearLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="crearLabel">Administrador de la plantilla de partidos por defecto</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" style="text-align: center;">
                <table class="table table-bordered table-sm animate__animated animate__faster animate__fadeInDown" id="table">
                    <thead>
                        <tr>
                            <th scope="col">FECHA</th>
                            <th scope="col">EQUIPO 1</th>
                            <th scope="col">EQUIPO 2</th>
                            <th scope="col">ACCIÓN</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let partido of partidos">
                            <td scope="row">{{partido.fecha}}</td>
                            <td scope="row">{{partido.contrincante1}}</td>
                            <td scope="row">{{partido.contrincante2}}</td>
                            <td scope="row"><i (click)="eliminarPartidioPlantilla(partido)" class="icofont-ui-delete" style="color: #dc3545"></i></td>
                        </tr>
                    </tbody>
                </table>
                <div class="row">
                    <div class="col-sm mb-2">
                        <input type="date" data-date-format="DD MMMM" class="form-control" id="Fecha" placeholder="Ingrese la Fecha" style="height: 30px;" (keyup.enter)="cargarPartidoPlantilla()">
                    </div>
                    <div class="col-sm mb-2">
                        <input type="text" autocomplete="off" class="form-control input-sm" id="Equipo1" placeholder="Ingrese el equipo 1" style="height: 30px;" (keyup.enter)="cargarPartidoPlantilla()">
                    </div>
                    <div class="col-sm mb-2">
                        <input type="text" autocomplete="off" class="form-control input-sm" id="Equipo2" placeholder="Ingrese el equipo 2" style="height: 30px;" (keyup.enter)="cargarPartidoPlantilla()">
                    </div>
                </div>
                <a (click)="cargarPartidoPlantilla()" class="btn-agregar-partido" style="padding: .25rem .5rem;font-size: .875rem;line-height: 1.5;">
                    <i class="icofont-ui-add"></i> Agregar partido</a>
            </div>
            <div class="modal-footer">
                <button type="button" (click)="guardarPlantilla()" class="btn btn-primary" style="background: #ef6603;border-color: #ef6603;" data-dismiss="modal">Guardar</button>
                <button type="button" id="CloseButton" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
        </div>
    </div>
</div>